import { styled } from '@mui/material/styles';
import Iconify from '../iconify';

// ----------------------------------------------------------------------

const WHATSAPP_URL = 'https://wa.me/message/5WBUMSLTN6HPL1';

const StyledButton = styled('a')(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  right: 90,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 56,
  height: 56,
  borderRadius: '50%',
  backgroundColor: '#25D366',
  color: '#fff',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#128C7E',
  },
  boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
  [theme.breakpoints.down('sm')]: {
    bottom: 16,
    right: 16,
  },
}));

// ----------------------------------------------------------------------

export default function WhatsAppButton() {
  return (
    <StyledButton
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
    >
      <Iconify icon="mdi:whatsapp" width={32} />
    </StyledButton>
  );
}
